import React from 'react';
import qs from 'qs';
import { createBrowserHistory } from 'history';

// utils
import Loader from 'react-simple-loading';
import { observer } from 'mobx-react';
import moment from 'moment';

import callApi from '../../utils/callApi';

// constants
import {
  ANCHOR_FEATURED_LIST_SEGMENTS,
  ANCHOR_FEATURED_LIST_AUDITIONS,
  ANCHOR_FEATURED_LIST_GALLERIES,
  ANCHOR_VIDEOS_AND_GALLERIES,
  ANCHOR_FEATURED_LIST_CLIPSTORE_ITEMS_FOR_SALE,
  ANCHOR_FEATURED_LIST_CLIPSTORE_ITEMS_PURCHASED,
  ANCHOR_FEATURED_ALL_CLIPSTORE_ITEMS_FOR_SALE,
  ANCHOR_FEATURED_ALL_CLIPSTORE_ITEMS_PURCHASED,
  LIST_EPAY_PACKAGES_ITEM,
  ANCHOR_FEATURED_LIST_CLIPSTORE_ITEMS_EWALLET,
} from '../../constants/apiUrls/apiUrls';

// components
import PageSubnav from '../featuredComponents/PageSubnav';
import FeaturedItems from '../anchorComponents/FeaturedItems';
import { checkStatus } from '../App/services';
import { overrideStatusResponse } from '../../utils/overrideStatusResponse';
import { RootStoreContext } from '../../context';
import PayPerViewPurchaseModal from '../PayPerViewPurchaseModal/PayPerViewPurchaseModal';
import PayPerViewStore from '../../store/PayPerViewStore';
import AnchorStore from '../../store/AnchorStore';
import NotificationStore from '../../store/NotificationStore';

import PrivateGalleriesAndVideos from './PrivateGalleriesAndVideos/PrivateGalleriesAndVideos';
import SimpleVideoPlayer from './SimpleVideoPlayer';
import NoContentDisclaimer from './NoContentDisclaimer';
import { anchorIsNakedNewsLive } from '../../utils/helpers';

// const PageSubnavLinks = ['Segments', 'Galleries', 'Audition'];
const history = createBrowserHistory();
const nnLiveId = '241';

const CLIPSTORE_URLS = {
  ALL_NEW: ANCHOR_FEATURED_ALL_CLIPSTORE_ITEMS_FOR_SALE,
  ALL_PURCHASED: ANCHOR_FEATURED_ALL_CLIPSTORE_ITEMS_PURCHASED,
  ANCHOR_NEW: ANCHOR_FEATURED_LIST_CLIPSTORE_ITEMS_FOR_SALE,
  ANCHOR_PURCHASED: ANCHOR_FEATURED_LIST_CLIPSTORE_ITEMS_PURCHASED,
};
const RESOURCE_LIMIT = 9;

@observer
class FeaturedSection extends React.Component {
  static contextType = RootStoreContext;
  constructor(props) {
    super(props);
    window.FeaturedSection = this;
    this.queryParams = qs.parse(window.location.search, { ignoreQueryPrefix: true });
    this.state = {
      typeOfListing: 'segments',
      featuredItems: [],
      size: RESOURCE_LIMIT,
      isLoading: false,
      itemCount: 0,
      featuredDataReady: false,
      featureExists: {
        segments: false,
        galleries: false,
        audition: false,
        fanzone: false,
        clipstore: false,
      },
      subscribedToAnchor: false,
      privateGalleries: [],
      privateVideos: [],
      galleriesAndVideos: [],
      clipStoreItemsForSale: [],
      clipStoreItemsPurchased: [],
      user: {},
      pagination: {
        total: 0,
        page: 0,
        pageSize: 30,
        totalPages: 0,
      },
      payPerViewNewItemPage: 0,
      payPerViewNewItemTotalPages: 0,
      payPerViewPurchasedItemPage: 0,
      payPerViewPurchasedItemTotalPages: 0,
      loadingFanZoneContent: false,
      currentFeaturedItemsCount: 0,
      allDataLoaded: false,
      hiddenLibrariesCount: 0,
      clipStoreNewHiddenLibrariesCount: 0,
      clipStorePurchasedHiddenLibrariesCount: 0,
      isBanned: false,
      clipStoreLoading: false,
      totalNewPayPerViewItems: 0,
      totalPurchasedPayPerViewItems: 0,
      selectedClipPrice: { price: 0, title: '', id: 0, type: '' },
      packages: [],
    };
  }

  getUrlByTypeOfListing = (type) => {
    const typeOfListing = type || this.state.typeOfListing;

    switch (typeOfListing) {
      case 'segments':
        return ANCHOR_FEATURED_LIST_SEGMENTS;
      case 'audition':
        return ANCHOR_FEATURED_LIST_AUDITIONS;
      case 'galleries':
        return ANCHOR_FEATURED_LIST_GALLERIES;
      case 'clipstore':
        return ANCHOR_FEATURED_LIST_CLIPSTORE_ITEMS_FOR_SALE;
      default:
        return ANCHOR_FEATURED_LIST_SEGMENTS;
    }
  };

  loadMore = () => {
    const { size } = this.state;
    this.setState(
      {
        isLoading: true,
        size: size + RESOURCE_LIMIT,
        featuredItems: [],
      },
      () => this.setFeaturedItemsList()
    );
  };

  decideURL = (payPerViewNav, dropDownOption) => {
    if (payPerViewNav === 'New' && dropDownOption !== 'All') {

      return CLIPSTORE_URLS.ANCHOR_NEW;
    } else if (payPerViewNav === 'Purchased' && dropDownOption !== 'All') {

      return CLIPSTORE_URLS.ANCHOR_PURCHASED;
    } else if (payPerViewNav === 'New' && dropDownOption === 'All') {

      return CLIPSTORE_URLS.ALL_NEW;
    }

    return CLIPSTORE_URLS.ALL_PURCHASED;

  };

  fetchListingType = (type, payPerViewNav) => {
    const { size } = this.state;
    const { id, dropdownOption } = this.props;

    const urlByTypeOfListing = this.getUrlByTypeOfListing(type);
    let url;
    if (type !== 'clipstore') {
      url = urlByTypeOfListing.replace('{page}', 0).
        replace('{size}', size).
        replace('{id}', id);

      return callApi(url, 'get', {}, true, true, true);
    }
    url = this.decideURL(payPerViewNav, dropdownOption);
    url = url.replace('{page}', 0).
      replace('{size}', RESOURCE_LIMIT).
      replace('{id}', id);

    return callApi(url, 'get', {}, {}, {}, true, true, true);
  };

  setFeaturedItemsList = (type) => {
    const { currentFeaturedItemsCount } = this.state;

    this.fetchListingType(type).
      then((res) => {
        // Logic for removing the 'Load More' button on Segments and Galleries sections
        const allDataLoaded = (res.data.length - currentFeaturedItemsCount < RESOURCE_LIMIT);

        this.setState({
          featuredItems: res.data,
          isLoading: false,
          currentFeaturedItemsCount: res.data.length,
          allDataLoaded,
        });
      });
  };

  setFeaturedItemExistence = (data, featuredItem) => {
    if (data?.length > 0 || (Object.keys(data).length > 0)) {
      this.setState((state) => {
        return {
          featureExists: {
            ...state.featureExists,
            [featuredItem]: true,
          },
        };
      });
    }
  };

  getFormattedDates(content) {
    let initialStartDate = new Date(content?.[content.length - 1]?.date);
    let initialEndDate = new Date(content?.[0]?.date);

    initialStartDate = moment(new Date(initialStartDate.getFullYear(), initialStartDate.getMonth(), 1));
    initialEndDate = moment(new Date(initialEndDate.getFullYear(), initialEndDate.getMonth() + 1, 0));
    const startDate = moment(initialStartDate).format('YYYY-MM-DDTHH:mm:ss');
    const endDate = moment(initialEndDate).format('YYYY-MM-DDTHH:mm:ss');

    return { startDate, endDate };
  }

  setClipStorePackages = () => {
    const { user } = this.props;
    const username = sessionStorage.getItem('username') || (user?.user && user?.user?.username);
    const token = sessionStorage.getItem('token') || (user?.user && user?.user?.token);
    callApi(LIST_EPAY_PACKAGES_ITEM, 'get', { token, userName: username }, {}, {}, false, false, false).
      then((res) => {
        this.setState({ packages: res.data.products });
      }).catch(() => NotificationStore.error('Error getting payment packages. Try refreshing the page.'));
  };

  setListingTypeFromUrlParams = () => {
    const { location } = this.props;
    if (location.search) {
      const parsedSearch = qs.parse(location.search, { ignoreQueryPrefix: true });

      switch (parsedSearch.filter) {
        case 'segments':
          this.setState({ typeOfListing: parsedSearch.filter });
          break;

        case 'galleries':
          this.setState({ typeOfListing: parsedSearch.filter });
          break;

        case 'audition':
          this.setState({ typeOfListing: parsedSearch.filter });
          break;

        case 'fanzone':
          this.setState({ typeOfListing: parsedSearch.filter });
          break;

        case 'clipstore':
          this.setState({ typeOfListing: parsedSearch.filter });
          break;

        default:
          break;
      }
    }
  };

  handleClipStorePageContentFetch = () => {
    const { isClipStorePage, user } = this.props;
    if (isClipStorePage) {
      this.fetchListingType('clipstore', 'New').
        then((payPerViewRes) => {
          this.setFeaturedItemExistence(payPerViewRes.data, 'clipstore');
          this.setState({
            totalNewPayPerViewItems: payPerViewRes.data.totalElements,
            payPerViewNewItemTotalPages: payPerViewRes.data.totalPages,
            clipStoreItemsForSale: payPerViewRes.data.content,
          });
          if (user.authenticated) {
            this.fetchListingType('clipstore', 'Purchased').
              then((res) => {
                this.setFeaturedItemExistence(res.data, 'clipstore');
                this.setState({
                  payPerViewPurchasedItemTotalPages: res.data.totalPages,
                  totalPurchasedPayPerViewItems: res.data.totalElements,
                });
              });
          }
        });
    }
  };

  setFeaturedItemsFromResponse = (isNNLive, showFanZone, segmentsRes, galleriesRes, auditionContent) => {
    const { location } = this.props;
    if (location.search === '?filter=clipstore' || location.pathname === '/clip-store') {
      PayPerViewStore.setPayPerViewNav('New');
      this.setState({ typeOfListing: 'clipstore', featuredDataReady: true });
    } else if ((location.search === '?filter=fanzone' && showFanZone) || isNNLive) {
      this.setDefaultFeature('fanzone');
      this.setState({ featuredDataReady: true });
    } else {
      if (segmentsRes.data.length === 0) {
        if (galleriesRes.data.length) {
          this.setDefaultFeature('galleries');
        } else if (auditionContent && auditionContent.data.length) {
          this.historyPush('audition');
        } else if (this.state.itemCount > 0 && showFanZone) {
          this.setDefaultFeature('fanzone');
        }
      } else {
        this.setDefaultFeature('segments');
      }
      this.setState({ featuredDataReady: true });
    }
  }

  fetchAllContent = () => {
    const { user, showFanZone, id, showClipStore } = this.props;
    const isNNLive = anchorIsNakedNewsLive(id);
    let auditionContent = null;
    const promises = [
      this.fetchListingType('segments'),
      this.fetchListingType('galleries'),
      this.fetchListingType('audition'),
    ];
    if (showClipStore) {
      promises.push(this.fetchListingType('clipstore', 'New'));
    }
    if (user.authenticated) {
      promises.push(this.fetchListingType('clipstore', 'Purchased'));
    }

    Promise.allSettled(promises).then((responses) => {
      const [segmentsRes, galleriesRes, auditionRes = [], newClipsRes = {}, purchasedClipsRes = {}] = responses;
      this.setFeaturedItemExistence(segmentsRes?.value?.data, 'segments');
      this.setFeaturedItemExistence(galleriesRes?.value?.data, 'galleries');
      if (auditionRes?.value?.data) {
        this.setFeaturedItemExistence(auditionRes?.value?.data, 'audition');
      }
      auditionContent = auditionRes?.value;
      if (newClipsRes?.value?.data) {
        this.setFeaturedItemExistence(newClipsRes?.value?.data, 'clipstore');
        this.setState({
          totalNewPayPerViewItems: newClipsRes?.value?.data?.totalElements,
          payPerViewNewItemTotalPages: newClipsRes?.value?.data?.totalPages,
          clipStoreItemsForSale: newClipsRes?.value?.data?.content,
        });
      }
      if (purchasedClipsRes?.value?.data) {
        this.setFeaturedItemExistence(purchasedClipsRes?.value?.data, 'clipstore');
        this.setState({
          payPerViewPurchasedItemTotalPages: purchasedClipsRes?.value?.data?.totalPages,
          totalPurchasedPayPerViewItems: purchasedClipsRes?.value?.data?.totalElements,
          clipStoreItemsPurchased: purchasedClipsRes?.value?.data?.content,
        });
      }
      this.setFeaturedItemsFromResponse(isNNLive, showFanZone, segmentsRes?.value, galleriesRes?.value, auditionContent);
    })
  }

  componentDidMount = () => {
    PayPerViewStore.setShowPayPerViewModal(false);
    PayPerViewStore.setPayPerViewNav('New');
    this.handleClipStorePageContentFetch();
    this.setClipStorePackages();
    this.setListingTypeFromUrlParams();
    this.fetchAllContent();
    this.checkSubscriptionStatus();
  };

  // used only when there are no segments.
  // feature can be of type segments, fanzone, audition, galleries
  setDefaultFeature = (feature) => {
    this.historyPush(feature);
    this.setFeaturedItemsList(feature);
    this.setState({ typeOfListing: feature });
  };

  checkSubscriptionStatus = async() => {
    const { id } = this.props;

    const { error, data } = await checkStatus();

    if (!error) {
      await overrideStatusResponse(data);

      const anchorSubscriptions = data?.data?.user?.account.anchorSubscriptions;
      const isAnchor = data?.data?.user?.account?.anchor;
      this.checkIfUserIsWhitelisted(data);

      if (anchorSubscriptions) {
        const subscribed = anchorSubscriptions.filter((anchor) => anchor.subCategory === id);
        let isBanned = false;

        if (subscribed.length > 0) {
          isBanned = subscribed[0].isBanned;
          this.props.setBanStatus(isBanned);
        }

        if (subscribed.length > 0 || isAnchor) {
          this.setState({ subscribedToAnchor: true, user: data.data.user, isBanned });
        } else {
          this.setState({ subscribedToAnchor: false, isBanned });
        }

      }
    } else {
      console.error(error);
    }
  };

  checkIfUserIsWhitelisted = (res) => {
    const { featureExists } = this.state;

    const whitelisted = res.data.features.includes('ANCHOR_PORTAL');

    if (whitelisted) {
      const features = {
        ...featureExists,
        fanzone: whitelisted,
        clipstore: (this.props.id === nnLiveId || whitelisted),
      };

      this.setState({ featureExists: features },
        this.fetchPrivateVideosAndGalleries,
        (this.props.id === nnLiveId && this.fetchPayPerViewVideosAndGalleries)
      );
    }
  };

  fetchPayPerViewVideosAndGalleries = (selectedLink) => {
    const {
      clipStoreItemsForSale,
      clipStoreItemsPurchased,
      payPerViewNewItemPage,
      payPerViewPurchasedItemPage,
    } = this.state;

    const { id, dropdownOption } = this.props;
    const anchorID = id || PayPerViewStore.currentlySelectedAnchorID;
    let url = this.decideURL(selectedLink, dropdownOption);
    this.setState({ isLoading: true });

    url = url.replace('{page}', (selectedLink === 'New' ? payPerViewNewItemPage : payPerViewPurchasedItemPage)).
      replace('{size}', RESOURCE_LIMIT).
      replace('{id}', anchorID);

    callApi(url, 'get', {}, {}, {}, true, true, true).
      then((res) => {
        const { totalElements } = res.data;

        if (res.status === 200 && res.data) {
          // Display only videos and galleries that are not empty
          const galleriesAndVideosNew = res.data.content.filter((item) => item.type === 'VIDEO' || item.imageCount >= 0);

          // Keep track of the number of hidden Galleries (needed for hiding the Load More button logic)
          const clipStoreHiddenLibrariesCount = res.data.content.length - galleriesAndVideosNew.length;

          // Load more - add new data to the ones already displayed

          const moreGalleriesAndVideos = (selectedLink === 'New') ? [...clipStoreItemsForSale, ...galleriesAndVideosNew] : [...clipStoreItemsPurchased, ...galleriesAndVideosNew];

          selectedLink === 'New' ? this.setState({
            clipStoreItemsForSale: moreGalleriesAndVideos,
            payPerViewNewItemPage: res.data.pageNumber,
            totalNewPayPerViewItems: totalElements,
          }, () => this.setState({ isLoading: false })) : this.setState({
            clipStoreItemsPurchased: moreGalleriesAndVideos,
            payPerViewPurchasedItemPage: res.data.pageNumber,
            totalPurchasedPayPerViewItems: totalElements,
          }, () => this.setState({ isLoading: false }));

          if (clipStoreHiddenLibrariesCount > 0) {
            selectedLink === 'New' ? this.setState({ clipStoreNewHiddenLibrariesCount: clipStoreHiddenLibrariesCount }) : this.setState({ clipStorePurchasedHiddenLibrariesCount: clipStoreHiddenLibrariesCount });
            this.setState({ loadingFanZoneContent: false });
          } else {
            this.setState({ loadingFanZoneContent: false });
          }
        } else {

        }
      }).
      catch((error) => {
        console.error(error);
      });
  };

  fetchPrivateVideosAndGalleries = () => {
    const { galleriesAndVideos } = this.state;
    const { id, pageItemsShown } = this.props;
    const { page, pageSize } = this.state.pagination;

    const params = {
      page,
      size: pageItemsShown || pageSize,
    };

    const url = ANCHOR_VIDEOS_AND_GALLERIES.replace('{anchorId}', encodeURIComponent(id));
    callApi(url, 'get', params, {}, {}, true, true, true).
      then((res) => {
        if (res.status === 200 && res.data) {
          const { totalElements } = res.data;
          this.setState({ itemCount: totalElements });
          this.props.setItemsCount && this.props.setItemsCount(totalElements);
          const pagination = {
            ...this.state.pagination,
            total: res.data.totalElements,
            pageSize: this.state.size + RESOURCE_LIMIT,
            page: res.data.pageNumber,
            totalPage: res.data.totalPages,
          };
          // Display only videos and galleries that are not empty
          const galleriesAndVideosNew = res.data.content.filter((item) => item.type === 'VIDEO' || item.imageCount > 0);

          // Keep track of the number of hidden Galleries (needed for hiding the Load More button logic)
          const hiddenLibrariesCount = res.data.content.length - galleriesAndVideosNew.length;

          // Load more - add new data to the ones already displayed
          const moreGalleriesAndVideos = [...galleriesAndVideos, ...galleriesAndVideosNew];

          if (hiddenLibrariesCount > 0) {
            this.setState({ loadingFanZoneContent: false, galleriesAndVideos: moreGalleriesAndVideos, pagination, hiddenLibrariesCount });
          } else {
            this.setState({ loadingFanZoneContent: false, galleriesAndVideos: moreGalleriesAndVideos, pagination });
          }
        }
      }).
      catch((error) => {
        console.error(error);
      });
  };

  handlePageChanged = (pageNum) => {
    let { page } = this.state.pagination;
    const next = ++page;

    this.setState((state) => {
      return {
        loadingFanZoneContent: true,
        pagination: { ...state.pagination, page: next },
      };
    }, () => {
      this.fetchPrivateVideosAndGalleries();
    });
  };

  handleFreeContentForFanPlus = (id, price, type) => {
    const url = ANCHOR_FEATURED_LIST_CLIPSTORE_ITEMS_EWALLET.replace('{anchorId}', encodeURIComponent(this.props.id));
    const body = JSON.stringify({
      itemId: id,
      price,
      itemType: type,
    });
    this.setState({ clipStoreLoading: true });
    callApi(url, 'post', {}, body, {}, true, true, true).then((res) => {
      if (res.status === 200) {
        this.setState({ clipStoreLoading: false });
        this.openPurchased();
      }
    }).catch((e) => {
      this.setState({ clipStoreLoading: false });
    });
  };

  handlePayPerViewPageChanged = (pageNum) => {
    const { payPerViewNav } = PayPerViewStore;
    const { payPerViewNewItemPage, payPerViewPurchasedItemPage } = this.state;
    let currentPage = (payPerViewNav === 'New' ? payPerViewNewItemPage : payPerViewPurchasedItemPage);
    const next = ++currentPage;

    payPerViewNav === 'New' ? this.setState({ loadingFanZoneContent: true, payPerViewNewItemPage: next }, () => {
      this.fetchPayPerViewVideosAndGalleries(payPerViewNav);
    }) : this.setState({ loadingFanZoneContent: true, payPerViewPurchasedItemPage: next }, () => {
      this.fetchPayPerViewVideosAndGalleries(payPerViewNav);
    });
  };

  historyPush = (filter) => {
    const { location } = this.props;
    const path = process.env.REACT_APP_MR_SUBFOLDER ? `${process.env.REACT_APP_MR_SUBFOLDER}${location.pathname}` : location.pathname;
    const currentUrlParams = new URLSearchParams(window.location.search);
    currentUrlParams.set('filter', filter);
    history.push(`${path}?${currentUrlParams}`);
  };

  setPayPerViewNav = (e) => {
    const { payPerViewNav } = PayPerViewStore;
    const clickedLink = e.target.classList[0];

    if (payPerViewNav !== clickedLink) {
      PayPerViewStore.setPayPerViewNav(clickedLink);
      this.clearClipStoreItems();
      this.fetchPayPerViewVideosAndGalleries(clickedLink);
    }
  };

  setPayPerViewClipData = (price, title, id, type) => {
    this.setState({ selectedClipPrice: { price, title, id, type } });
  };

  openPayPerViewModal = (price, title, id, type, customPriceForFanPlus) => {
    const { user } = this.props;
    const isAnchor = user && user.user ? user.user.account.anchor : false;
    this.setPayPerViewClipData(price, title, id, type);

    if (!isAnchor && customPriceForFanPlus === 0 && price === 0) {
      this.handleFreeContentForFanPlus(id, price, type);
    }

    if (!isAnchor && (price !== 0 && title !== '')) {
      PayPerViewStore.setShowPayPerViewModal(true);
    }

    PayPerViewStore.setPurchasedClip({ id, type: type.toString() });
  };

  closePayPerViewModal = () => {
    PayPerViewStore.setShowPayPerViewModal(false);
    PayPerViewStore.setStatusMessage('');
  };

  openPurchased = () => {
    this.clearClipStoreItems();
    this.fetchPayPerViewVideosAndGalleries('Purchased');
  };

  startPurchaseEventTimerCountDown = () => {
    PayPerViewStore.setTimerStarted(true);
    const timer = setTimeout(() => {

      if (PayPerViewStore.timerStarted && PayPerViewStore.intervalID) {
        PayPerViewStore.setStatusMessage('There was an error. Please try again later.');
        PayPerViewStore.setShowPayPerViewModal(true);
        PayPerViewStore.setPaymentLoading(false);
      } else {
        PayPerViewStore.setTimerStarted(false);
      }
    }, 30000);
    PayPerViewStore.setIntervalID(timer);
  };

  componentWillUnmount() {
    if (PayPerViewStore.intervalID !== null) {
      clearTimeout(PayPerViewStore.intervalID);
      PayPerViewStore.setIntervalID(null);
    }
    PayPerViewStore.setPayPerViewNav('New');
  }

  handleClick = (e) => {
    const { typeOfListing } = this.state;
    const preparedTargetValue = e.currentTarget.text.toLowerCase().replace(/\s/g, '');
    e.preventDefault();

    switch (preparedTargetValue) {
      case 'galleries&videos':
        this.historyPush('fanzone');
        break;
      case 'segments':
        this.historyPush(preparedTargetValue);
        break;

      case 'galleries':
        this.historyPush(preparedTargetValue);
        break;

      case 'audition':
        this.historyPush(preparedTargetValue);
        break;

      case 'fanzone':
        this.historyPush(preparedTargetValue);
        break;

      case 'clipstore':
        this.historyPush(preparedTargetValue);
        break;

      default:
        break;
    }
    if ((preparedTargetValue !== typeOfListing) && preparedTargetValue === 'clipstore') {
      PayPerViewStore.setPayPerViewNav('New');
      this.setState({ typeOfListing: preparedTargetValue, featuredItems: [], currentFeaturedItemsCount: 0, size: RESOURCE_LIMIT, clipStoreItemsForSale: [], clipStoreItemsPurchased: [], payPerViewNewItemPage: 0, payPerViewPurchasedItemPage: 0 }, () => this.fetchPayPerViewVideosAndGalleries('New'));
    } else if (preparedTargetValue !== typeOfListing) {
      this.setState({ typeOfListing: preparedTargetValue === 'galleries&videos' ? 'fanzone' : preparedTargetValue, featuredItems: [], currentFeaturedItemsCount: 0, size: RESOURCE_LIMIT, clipStoreItemsForSale: [], clipStoreItemsPurchased: [] }, () => this.setFeaturedItemsList());
    }
  };

  clearClipStoreItems = () => {
    this.setState({
      payPerViewNewItemPage: 0,
      payPerViewPurchasedItemPage: 0,
      clipStoreItemsPurchased: [],
      clipStoreItemsForSale: [],
      clipStoreNewHiddenLibrariesCount: 0,
      clipStorePurchasedHiddenLibrariesCount: 0,
      totalNewPayPerViewItems: 0,
      totalPurchasedPayPerViewItems: 0,
    });
  };

  componentDidUpdate(prevProps) {
    const { dropdownOption } = this.props || {};
    if ((prevProps.dropdownOption && prevProps.dropdownOption !== dropdownOption) || PayPerViewStore.shouldRefreshItemsList) {
      this.setState({ dropDownOption: dropdownOption }, () => {
        this.fetchPayPerViewVideosAndGalleries('New');
      });
      this.clearClipStoreItems();
      PayPerViewStore.setPayPerViewNav('New');
      PayPerViewStore.setShouldRefreshItemsList(false);
    }
  }

  render() {
    const {
      typeOfListing,
      featuredItems,
      isLoading,
      featuredDataReady,
      subscribedToAnchor,
      galleriesAndVideos,
      loadingFanZoneContent,
      allDataLoaded,
      hiddenLibrariesCount,
      itemCount,
      totalNewPayPerViewItems,
      clipStorePurchasedItemCount,
      clipStoreNewHiddenLibrariesCount,
      clipStorePurchasedHiddenLibrariesCount,
      clipStoreItemsForSale,
      clipStoreItemsPurchased,
      clipStoreLoading,
      selectedClipPrice,
      modalMessage,
      featureExists,
    } = this.state;
    const {
      anchorName,
      id,
      anchorShortUrl,
      isClipStorePage,
      isNakedNewsLive,
      showClipStore,
      showFanZone,
    } = this.props;
    const { anchorsWithFanzone: anchorsWithClipStore } = AnchorStore;
    const isAnchor = this.props.user?.user?.account?.anchor;
    const isNNLivePage = id === nnLiveId;
    const showPageSubNav = featuredDataReady && !isClipStorePage && (typeOfListing === 'segments' || 'galleries' || 'audition' || 'fanzone' || 'clipstore');
    const shouldShowFeaturedItems = typeOfListing !== 'audition' && typeOfListing !== 'fanzone' && typeOfListing !== 'clipstore';
    const showAuditionClip = typeOfListing === 'audition' && featuredItems.position;
    const isFanzone = typeOfListing === 'fanzone';
    const paymentIsLoading = PayPerViewStore.paymentLoading || clipStoreLoading;
    const { anchors: allAnchors } = AnchorStore;

    return (
      <React.Fragment>
        <PageSubnav
          featureExists={featureExists}
          handleClick={this.handleClick}
          id={id}
          isNNLivePage={isNNLivePage}
          itemCount={itemCount}
          showClipStore={showClipStore}
          showFanZone={showFanZone}
          showPageSubNav={showPageSubNav}
          subscribedToAnchor={subscribedToAnchor}
          typeOfListing={typeOfListing}
        />
        {shouldShowFeaturedItems &&
          <div className="fan-zone-anchor-page">
            <FeaturedItems
              allDataLoaded={allDataLoaded}
              featuredItems={featuredItems}
              isLoading={isLoading}
              loadMore={this.loadMore}
              typeOfListing={typeOfListing}
            />
          </div>}
        {showAuditionClip &&
          <div className="content audition-page-player fan-zone-anchor-page">
            <SimpleVideoPlayer audition={featuredItems} />
          </div>}
        {isFanzone &&
          <div className={`content ${anchorShortUrl === 'live' ? 'live-page-content' : 'fan-zone-anchor-page'}`}>
            <PrivateGalleriesAndVideos
              allAnchors={allAnchors}
              anchorId={id}
              anchorShortUrl={anchorShortUrl}
              anchorsWithClipStore={anchorsWithClipStore}
              galleriesAndVideos={galleriesAndVideos}
              galleriesAndVideosCount={itemCount}
              handlePageChanged={this.handlePageChanged}
              hiddenLibrariesCount={hiddenLibrariesCount}
              isLoading={loadingFanZoneContent}
              isNakedNewsLive={isNakedNewsLive}
              setPayPerViewClipData={this.setPayPerViewClipData}
              subscribed={subscribedToAnchor}
              typeOfListing={typeOfListing}
              user={this.props.user}
            />
          </div>}
        {paymentIsLoading &&
          <div className="payment-loading-overlay">
            <Loader />
          </div>}
        {(typeOfListing === 'clipstore') && featuredDataReady &&
          <>
            <div className="pay-per-view-nav container">
              <div
                className={`New ${PayPerViewStore.payPerViewNav === 'New' ? 'active' : ''}`}
                onClick={this.setPayPerViewNav}
              >
                New
              </div>
              {!isAnchor &&
                <div
                  className={`Purchased ${!this.props.user.authenticated && 'disable-click'} ${PayPerViewStore.payPerViewNav === 'Purchased' ? 'active' : ''}`}
                  onClick={this.setPayPerViewNav}
                >
                  Purchased
                </div>}
            </div>
            <div className={`content ${isNNLivePage ? 'live-page-content' : 'fan-zone-anchor-page pay-per-view'}`}>
              {PayPerViewStore.payPerViewNav === 'New' ? <>
                {!isLoading && totalNewPayPerViewItems > 0 &&
                <>
                  {PayPerViewStore.showPayPerViewModal &&
                  <PayPerViewPurchaseModal
                    anchorId={PayPerViewStore.currentlySelectedAnchorId || this.props.id}
                    anchorName={anchorName}
                    anchorShortUrl={anchorShortUrl}
                    anchorsWithClipStore={anchorsWithClipStore}
                    buyClip={this.buyPayPerViewClip}
                    clipId={selectedClipPrice.id}
                    closeModal={this.closePayPerViewModal}
                    fetchPayPerViewVideosAndGalleries={this.fetchPayPerViewVideosAndGalleries}
                    message={modalMessage}
                    price={selectedClipPrice.price}
                    programs={this.state.packages}
                    startPurchaseTimer={this.startPurchaseEventTimerCountDown}
                    title={selectedClipPrice.title}
                    type={selectedClipPrice.type}
                    user={this.props.user}
                  />}
                  <div className="container total-posts">{totalNewPayPerViewItems} new posts for sale</div>
                  <PrivateGalleriesAndVideos
                    allAnchors={allAnchors}
                    anchorId={id}
                    anchorsWithClipStore={anchorsWithClipStore}
                    galleriesAndVideos={clipStoreItemsForSale}
                    galleriesAndVideosCount={totalNewPayPerViewItems}
                    handlePageChanged={this.handlePayPerViewPageChanged}
                    hiddenLibrariesCount={clipStoreNewHiddenLibrariesCount}
                    isClipStorePage={isClipStorePage}
                    isLoading={loadingFanZoneContent}
                    isNakedNewsLive={isNakedNewsLive}
                    isPurchasedTab={false}
                    openPayPerViewModal={this.openPayPerViewModal}
                    payPerViewNav={PayPerViewStore.payPerViewNav}
                    setPayPerViewClipData={this.setPayPerViewClipData}
                    subscribed={subscribedToAnchor}
                    typeOfListing={typeOfListing}
                    user={this.props.user}
                  />
                </>
                }
                {isLoading && <div style={{ minHeight: 500, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <Loader color="#fff" />
                </div>}
                <NoContentDisclaimer
                  anchorName={anchorName}
                  showDisclaimer={!isLoading && totalNewPayPerViewItems < 1}
                />
              </> : <>
                {clipStoreItemsPurchased.length > 0 ? <PrivateGalleriesAndVideos
                  allAnchors={allAnchors}
                  anchorId={id}
                  anchorsWithClipStore={anchorsWithClipStore}
                  galleriesAndVideos={clipStoreItemsPurchased}
                  galleriesAndVideosCount={clipStorePurchasedItemCount}
                  handlePageChanged={this.handlePayPerViewPageChanged}
                  hiddenLibrariesCount={clipStorePurchasedHiddenLibrariesCount}
                  isClipStorePage={isClipStorePage}
                  isLoading={loadingFanZoneContent}
                  isNakedNewsLive={isNakedNewsLive}
                  isPurchasedTab={true}
                  payPerViewNav={PayPerViewStore.payPerViewNav}
                  selectedClipPrice={selectedClipPrice}
                  setPayPerViewClipData={this.setPayPerViewClipData}
                  subscribed={subscribedToAnchor}
                  typeOfListing={typeOfListing}
                  user={this.props.user}
                                                      /> : <div className="purchased-tab">You have not purchased any exclusive content yet.</div>}
              </>
              }
            </div>
          </>}
      </React.Fragment>
    );
  }
}

export default FeaturedSection;

FeaturedSection.defaultProps = { dropdownOption: 'Anchors', isNakedNewsLive: false };
